import passageInstruction from '../daze_passage_instructions.json';
import directionInstruction from '../daze_direction.json';
import clickOk from '../click_ok.json';
import scrollIntroInstruction from '../daze_scroll_intro.json';
import scrollDownInstruction from '../daze_scroll_down.json';
import scrollReadyInstruction from '../daze_ready.json';
import scrollInstruction from '../daze_ready_instructions.json';
import scrollReadyClickOk from '../daze_ready_click_ok.json';
import modelCorrectResponse from '../maze_model_correct_answer_selected.json';
import modelIncorrectResponse from '../maze_model_incorrect_answer_selected.json';
import modelSecondIncorrectResponse from '../maze_model_incorrect_answer_selected_twice.json';
import modelInstructionStart from '../maze_model_sentence_start.json';
import modelInstructionEnd from '../maze_model_sentence_end.json';
import modelOptionOne from '../maze_model_option_bus.json';
import modelOptionTwo from '../maze_model_option_pen.json';
import modelOptionThree from '../maze_model_option_work.json';
import practiceInstruction from '../daze_practice_avatar.json';
import practiceIntro from '../maze_practice_intro.json';
import practiceEnd from '../maze_practice_sentence_end.json';
import practiceOptionOne from '../maze_practice_option_afternoon.json';
import practiceOptionTwo from '../maze_practice_option_library.json';
import practiceOptionThree from '../maze_practice_option_morning.json';
import practiceCorrectAnswerSelected from '../maze_practice_correct_answer_selected.json';
import practiceIncorrectAnswerSelected from '../maze_practice_incorrect_answer_selected.json';
import practiceIncorrectAnswerSelectedTwice from '../maze_practice_incorrect_answer_selected_twice.json';

import passageInstructionAudio from '../../sounds/daze_passage_instructions.mp3';
import directionInstructionAudio from '../../sounds/daze_direction.mp3';
import clickOkAudio from '../../sounds/click_ok.mp3';
import scrollIntroInstructionAudio from '../../sounds/daze_scroll_intro.mp3';
import scrollDownInstructionAudio from '../../sounds/daze_scroll_down.mp3';
import scrollReadyInstructionAudio from '../../sounds/daze_ready.mp3';
import scrollInstructionAudio from '../../sounds/daze_ready_instructions.mp3';
import scrollReadyClickOkAudio from '../../sounds/daze_ready_click_ok.mp3';
import modelCorrectResponseAudio from '../../sounds/maze_model_correct_answer_selected.mp3';
import modelIncorrectResponseAudio from '../../sounds/maze_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStartAudio from '../../sounds/maze_model_sentence_start.mp3';
import modelInstructionEndAudio from '../../sounds/maze_model_sentence_end.mp3';
import modelOptionOneAudio from '../../sounds/maze_model_option_bus.mp3';
import modelOptionTwoAudio from '../../sounds/maze_model_option_pen.mp3';
import modelOptionThreeAudio from '../../sounds/maze_model_option_work.mp3';
import practiceInstructionAudio from '../../sounds/daze_practice_avatar.mp3';
import practiceIntroAudio from '../../sounds/maze_practice_intro.mp3';
import practiceEndAudio from '../../sounds/maze_practice_sentence_end.mp3';
import practiceOptionOneAudio from '../../sounds/maze_practice_option_afternoon.mp3';
import practiceOptionTwoAudio from '../../sounds/maze_practice_option_library.mp3';
import practiceOptionThreeAudio from '../../sounds/maze_practice_option_morning.mp3';
import practiceCorrectAnswerSelectedAudio from '../../sounds/maze_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelectedAudio from '../../sounds/maze_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwiceAudio from '../../sounds/maze_practice_incorrect_answer_selected_twice.mp3';

// Alyx English Audios
import passageInstructionAlyx from '../../sounds/alyx/english/daze_passage_instructions_alyx.mp3';
import directionInstructionAlyx from '../../sounds/alyx/english/daze_direction_alyx.mp3';
import clickOkAlyx from '../../sounds/alyx/english/click_ok_alyx.mp3';
import scrollIntroInstructionAlyx from '../../sounds/alyx/english/daze_scroll_intro_alyx.mp3';
import scrollDownInstructionAlyx from '../../sounds/alyx/english/daze_scroll_down_alyx.mp3';
import scrollReadyInstructionAlyx from '../../sounds/alyx/english/daze_ready_alyx.mp3';
import scrollInstructionAlyx from '../../sounds/alyx/english/daze_ready_instructions_alyx.mp3';
import scrollReadyClickOkAlyx from '../../sounds/alyx/english/daze_ready_click_ok_alyx.mp3';
import modelCorrectResponseAlyx from '../../sounds/alyx/english/maze_model_correct_answer_selected_alyx.mp3';
import modelIncorrectResponseAlyx from '../../sounds/alyx/english/maze_model_incorrect_answer_selected_twice_alyx.mp3';
import modelInstructionStartAlyx from '../../sounds/alyx/english/maze_model_sentence_start_alyx.mp3';
import modelInstructionEndAlyx from '../../sounds/alyx/english/maze_model_sentence_end_alyx.mp3';
import modelOptionOneAlyx from '../../sounds/alyx/english/maze_model_option_bus_alyx.mp3';
import modelOptionTwoAlyx from '../../sounds/alyx/english/maze_model_option_pen_alyx.mp3';
import modelOptionThreeAlyx from '../../sounds/alyx/english/maze_model_option_work_alyx.mp3';
import practiceInstructionAlyx from '../../sounds/alyx/english/daze_practice_avatar_alyx.mp3';
import practiceIntroAlyx from '../../sounds/alyx/english/maze_practice_intro_alyx.mp3';
import practiceEndAlyx from '../../sounds/alyx/english/maze_practice_sentence_end_alyx.mp3';
import practiceOptionOneAlyx from '../../sounds/alyx/english/maze_practice_option_afternoon_alyx.mp3';
import practiceOptionTwoAlyx from '../../sounds/alyx/english/maze_practice_option_library_alyx.mp3';
import practiceOptionThreeAlyx from '../../sounds/alyx/english/maze_practice_option_morning_alyx.mp3';
import practiceCorrectAnswerSelectedAlyx from '../../sounds/alyx/english/maze_practice_correct_answer_selected_alyx.mp3';
import practiceIncorrectAnswerSelectedAlyx from '../../sounds/alyx/english/maze_practice_incorrect_answer_selected_alyx.mp3';
import practiceIncorrectAnswerSelectedTwiceAlyx from '../../sounds/alyx/english/maze_practice_incorrect_answer_selected_twice_alyx.mp3';

import { selectAvatarAudio } from '../../common/alex/AlexUtils';

const clickOkAudioFile = selectAvatarAudio(clickOkAudio, clickOkAlyx);
const passageInstructionAudioFile = selectAvatarAudio(
    passageInstructionAudio,
    passageInstructionAlyx,
);
const directionInstructionAudioFile = selectAvatarAudio(
    directionInstructionAudio,
    directionInstructionAlyx,
);
const modelCorrectResponseAudioFile = selectAvatarAudio(
    modelCorrectResponseAudio,
    modelCorrectResponseAlyx,
);
const modelIncorrectResponseAudioFile = selectAvatarAudio(
    modelIncorrectResponseAudio,
    modelIncorrectResponseAlyx,
);
const modelInstructionStartAudioFile = selectAvatarAudio(
    modelInstructionStartAudio,
    modelInstructionStartAlyx,
);
const modelInstructionEndAudioFile = selectAvatarAudio(
    modelInstructionEndAudio,
    modelInstructionEndAlyx,
);
const modelOptionOneAudioFile = selectAvatarAudio(modelOptionOneAudio, modelOptionOneAlyx);
const modelOptionTwoAudioFile = selectAvatarAudio(modelOptionTwoAudio, modelOptionTwoAlyx);
const modelOptionThreeAudioFile = selectAvatarAudio(modelOptionThreeAudio, modelOptionThreeAlyx);
const practiceInstructionAudioFile = selectAvatarAudio(
    practiceInstructionAudio,
    practiceInstructionAlyx,
);
const practiceIntroAudioFile = selectAvatarAudio(practiceIntroAudio, practiceIntroAlyx);
const practiceOptionOneAudioFile = selectAvatarAudio(practiceOptionOneAudio, practiceOptionOneAlyx);
const practiceOptionTwoAudioFile = selectAvatarAudio(practiceOptionTwoAudio, practiceOptionTwoAlyx);
const practiceOptionThreeAudioFile = selectAvatarAudio(
    practiceOptionThreeAudio,
    practiceOptionThreeAlyx,
);
const practiceEndAudioFile = selectAvatarAudio(practiceEndAudio, practiceEndAlyx);
const practiceCorrectAnswerSelectedAudioFile = selectAvatarAudio(
    practiceCorrectAnswerSelectedAudio,
    practiceCorrectAnswerSelectedAlyx,
);
const practiceIncorrectAnswerSelectedAudioFile = selectAvatarAudio(
    practiceIncorrectAnswerSelectedAudio,
    practiceIncorrectAnswerSelectedAlyx,
);
const practiceIncorrectAnswerSelectedTwiceAudioFile = selectAvatarAudio(
    practiceIncorrectAnswerSelectedTwiceAudio,
    practiceIncorrectAnswerSelectedTwiceAlyx,
);
const scrollIntroInstructionAudioFile = selectAvatarAudio(
    scrollIntroInstructionAudio,
    scrollIntroInstructionAlyx,
);
const scrollReadyInstructionAudioFile = selectAvatarAudio(
    scrollReadyInstructionAudio,
    scrollReadyInstructionAlyx,
);
const scrollInstructionAudioFile = selectAvatarAudio(scrollInstructionAudio, scrollInstructionAlyx);
const scrollDownInstructionAudioFile = selectAvatarAudio(
    scrollDownInstructionAudio,
    scrollDownInstructionAlyx,
);
const scrollReadyClickOkAudioFile = selectAvatarAudio(
    scrollReadyClickOkAudio,
    scrollReadyClickOkAlyx,
);

const MAZE_CAPTIONS = {
    [passageInstructionAudioFile]: passageInstruction,
    [clickOkAudioFile]: clickOk,
    [directionInstructionAudioFile]: directionInstruction,
    [modelCorrectResponseAudioFile]: modelCorrectResponse,
    [modelIncorrectResponseAudioFile]: modelIncorrectResponse,
    [modelIncorrectResponseAudioFile]: modelSecondIncorrectResponse,
    [modelInstructionStartAudioFile]: modelInstructionStart,
    [modelInstructionEndAudioFile]: modelInstructionEnd,
    [modelOptionOneAudioFile]: modelOptionOne,
    [modelOptionTwoAudioFile]: modelOptionTwo,
    [modelOptionThreeAudioFile]: modelOptionThree,
    [practiceInstructionAudioFile]: practiceInstruction,
    [practiceIntroAudioFile]: practiceIntro,
    [practiceOptionOneAudioFile]: practiceOptionOne,
    [practiceOptionTwoAudioFile]: practiceOptionTwo,
    [practiceOptionThreeAudioFile]: practiceOptionThree,
    [practiceEndAudioFile]: practiceEnd,
    [practiceCorrectAnswerSelectedAudioFile]: practiceCorrectAnswerSelected,
    [practiceIncorrectAnswerSelectedAudioFile]: practiceIncorrectAnswerSelected,
    [practiceIncorrectAnswerSelectedTwiceAudioFile]: practiceIncorrectAnswerSelectedTwice,
    [clickOkAudioFile]: clickOk,
    [scrollIntroInstructionAudioFile]: scrollIntroInstruction,
    [scrollReadyInstructionAudioFile]: scrollReadyInstruction,
    [scrollInstructionAudioFile]: scrollInstruction,
    [scrollDownInstructionAudioFile]: scrollDownInstruction,
    [scrollReadyClickOkAudioFile]: scrollReadyClickOk,
    [clickOkAudioFile]: clickOk,
};

export default MAZE_CAPTIONS;
